import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {Observable} from "rxjs";
import {BiblioService} from "../../services/biblio.service";

/**
 * Generated class for the BiblioPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-biblio',
  templateUrl: 'biblio.html',
})
export class BiblioPage {

  biblio$: Observable<string>;

  constructor(public navCtrl: NavController,
              private biblioService:BiblioService,
              public navParams: NavParams) {
    this.biblio$ = this.biblioService.get();
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/biblio/biblio.ts